import type { TFunction } from 'i18next';

import type { RangeType } from '@/types/attendanceFilter.types';

/**
 * Utilidades para cálculos de fechas y rangos
 */

const MONTH_KEYS = [
  'january', 'february', 'march', 'april',
  'may', 'june', 'july', 'august',
  'september', 'october', 'november', 'december',
] as const;

/**
 * Retorna las opciones de meses (value: '1'–'12') traducidas con i18n.
 * Útil para selectores de filtro donde el backend espera el número de mes.
 */
export function getMonthOptions(t: TFunction): { value: string; label: string }[] {
  return MONTH_KEYS.map((key, index) => ({
    value: String(index + 1),
    label: t(`common:months.${key}`),
  }));
}

/**
 * Calcula un rango de fechas basado en un tipo de rango y una fecha inicial
 */
export const calculateDateRange = (
  rangeType: RangeType,
  formatFunction: (date: Date) => string = (date) => date.toISOString().split('T')[0],
): { dateFrom: string; dateTo: string } => {
  const today = new Date();
  
  let dateFrom = formatFunction(today);
  let dateTo = formatFunction(today);
  
  switch (rangeType) {
    case 'TODAY':
      dateFrom = formatFunction(today);
      dateTo = formatFunction(today);
      break;
    case 'WEEK': {
      dateTo = formatFunction(today);
      const weekStart = new Date(today);
      weekStart.setDate(weekStart.getDate() - 7);
      dateFrom = formatFunction(weekStart);
      break;
    }
    case 'MONTH_1': {
      dateTo = formatFunction(today);
      const month1Start = new Date(today);
      month1Start.setMonth(month1Start.getMonth() - 1);
      dateFrom = formatFunction(month1Start);
      break;
    }
    case 'MONTH_6': {
      dateTo = formatFunction(today);
      const month6Start = new Date(today);
      month6Start.setMonth(month6Start.getMonth() - 6);
      dateFrom = formatFunction(month6Start);
      break;
    }
    case 'MONTH_12': {
      dateTo = formatFunction(today);
      const month12Start = new Date(today);
      month12Start.setMonth(month12Start.getMonth() - 12);
      dateFrom = formatFunction(month12Start);
      break;
    }
  }
  
  return { dateFrom, dateTo };
};
